/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenstrualCycleResponseDto
 */
export interface MenstrualCycleResponseDto {
    /**
     * Medication statement ID
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    id: string;
    /**
     * Patient identity
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    patientId: string;
    /**
     * Cycle regularity and length
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    cycleRegularityAndLength: string;
    /**
     * Flow Characteristic
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    flowCharacteristic: string;
    /**
     * Symptoms Experienced
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    symptomsExperienced: string;
    /**
     * Additional Information
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    additionalInformation: string;
    /**
     * Last updated timestamp
     * @type {string}
     * @memberof MenstrualCycleResponseDto
     */
    lastUpdated: string;
}

/**
 * Check if a given object implements the MenstrualCycleResponseDto interface.
 */
export function instanceOfMenstrualCycleResponseDto(value: object): value is MenstrualCycleResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('patientId' in value) || value['patientId'] === undefined) return false;
    if (!('cycleRegularityAndLength' in value) || value['cycleRegularityAndLength'] === undefined) return false;
    if (!('flowCharacteristic' in value) || value['flowCharacteristic'] === undefined) return false;
    if (!('symptomsExperienced' in value) || value['symptomsExperienced'] === undefined) return false;
    if (!('additionalInformation' in value) || value['additionalInformation'] === undefined) return false;
    if (!('lastUpdated' in value) || value['lastUpdated'] === undefined) return false;
    return true;
}

export function MenstrualCycleResponseDtoFromJSON(json: any): MenstrualCycleResponseDto {
    return MenstrualCycleResponseDtoFromJSONTyped(json, false);
}

export function MenstrualCycleResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenstrualCycleResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'patientId': json['patientId'],
        'cycleRegularityAndLength': json['cycleRegularityAndLength'],
        'flowCharacteristic': json['flowCharacteristic'],
        'symptomsExperienced': json['symptomsExperienced'],
        'additionalInformation': json['additionalInformation'],
        'lastUpdated': json['lastUpdated'],
    };
}

export function MenstrualCycleResponseDtoToJSON(json: any): MenstrualCycleResponseDto {
    return MenstrualCycleResponseDtoToJSONTyped(json, false);
}

export function MenstrualCycleResponseDtoToJSONTyped(value?: MenstrualCycleResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'patientId': value['patientId'],
        'cycleRegularityAndLength': value['cycleRegularityAndLength'],
        'flowCharacteristic': value['flowCharacteristic'],
        'symptomsExperienced': value['symptomsExperienced'],
        'additionalInformation': value['additionalInformation'],
        'lastUpdated': value['lastUpdated'],
    };
}

